import React from 'react'
import PropTypes from 'prop-types'
import { Card, Button, Text, Badge, Heading } from '@plurall/elo-beta'
import { isMobile } from 'utils'

import TableCustomResponsibles from '../TableCustomResponsibles'
import EmptyStateResponsible from '../EmptyStateResponsible'

import styles from './CardResponsiblesList.module.scss'
import MobileButton from 'App/components/MobileButton'

const CardResponsiblesList = ({ data, navigateToAccountApproval }) => {
  const isContainParants = data?.person?.parents?.length > 0

  const mobileButton = () => (
    <span className={styles.buttonMobile}>
      <MobileButton onClick={navigateToAccountApproval} />
    </span>
  )

  return (
    <Card>
      <div className={styles.container}>
        <header className={styles['heading-card']}>
          <div>
            <Heading noParagraph element='h5'>
              Responsáveis vinculados {isContainParants && <Badge notification> Novo</Badge>}
            </Heading>
            <Text semibold shy size='t3'>
              Esses são os responsáveis que estão vinculados a sua conta
            </Text>
          </div>
          {isContainParants &&
            (isMobile() ? (
              mobileButton()
            ) : (
              <Button secondary onClick={navigateToAccountApproval}>
                Vincular responsável
              </Button>
            ))}
        </header>
        {isContainParants ? (
          <TableCustomResponsibles data={data} />
        ) : (
          <EmptyStateResponsible navigateToAccountApproval={navigateToAccountApproval} />
        )}
      </div>
    </Card>
  )
}
CardResponsiblesList.propTypes = {
  navigateToAccountApproval: PropTypes.func,
  data: PropTypes.shape({
    person: PropTypes.object,
  }),
}

export default CardResponsiblesList
